var _ellipse, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSun(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "1.5 2 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.99961,
    cy: 7.875,
    rx: 2.375,
    ry: 2.4,
    fill: "transparent"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.6002 7.875H3.2002"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7994 7.875H10.3994"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.30252 9.55463L4.60547 11.234"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3933 4.51642L9.69629 6.1958"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8 5.5L8 3.125"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8 12.625L8 10.25"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.30252 6.19537L4.60547 4.51599"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3933 11.2336L9.69629 9.5542"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSun);
export default __webpack_public_path__ + "static/media/sun.f5c6a24ab99fccd6dad16870cc6934c4.svg";
export { ForwardRef as ReactComponent };